"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _State = require("./State");

var _State2 = _interopRequireDefault(_State);

var _addons = require("@storybook/addons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _addons.makeDecorator)({
  name: "StateDecorator",
  parameterName: "state",
  wrapper: function wrapper(storyFn, context, _ref) {
    var parameters = _ref.parameters;

    if (parameters && parameters.store) {
      return _react2.default.createElement(
        _State2.default,
        { store: parameters.store, parseState: parameters.parseState },
        storyFn(context)
      );
    }

    return storyFn(context);
  }
});